<style>
.select__container {
  margin-top: 10px;
}
.select__container--el {
  display: flex;
  justify-content: space-between;
}
#printModal .v--modal-box.v--modal {
  min-height: 280px !important;
  min-width: 420px !important;
}
.modal__content {
  padding-top: 5px;
}
#printModal .v-input--selection-controls {
  margin-top: 0px;
}
#printModal .v-input--selection-controls.v-input .v-label {
  font-size: 12px;
}
#printModal *:not(.v-icon) {
  font-size: 12px;
}
#printModal .line__wrapper {
  align-items: center;
}
#printModal .line__button--add {
  margin-left: 5px;
}
</style>

<template>
  <Modal modalName="epanetControlsModal" :title="title" @saved="save">
    <v-form ref="form">
      <v-textarea v-model="settings" label="Ustawienia"> </v-textarea>
    </v-form>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    settings: "",
    title: "",
    attribute: undefined
  }),
  computed: {},
  watch: {},
  methods: {
    save() {
      this.$store.dispatch("changeSettings", {
        [this.attribute]: this.settings
      });
    },
    setEPANETTitle(level) {
      const dict = {
        SIMPLE: "Sterowanie proste",
        RULES: "Streowanie złożone"
      };
      this.title = dict[level];
      this.attribute = `EPANET_CONTROLS_${level}`;
      this.$store.dispatch("getSingleSettings", this.attribute).then(r => {
        this.settings = r;
      });
    }
  },
  mounted() {
    this.$root.$on("setEPANETTitle", this.setEPANETTitle);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/EpanetControls.vue